import React, { useContext, useMemo } from 'react';

import connect from 'components/lib/connect';

export const DEFAULT_IS_FEATURE_ENABLED_CONTEXT = null;

const CurrentAgentContext = React.createContext({});
export default CurrentAgentContext;

export function CurrentAgentProviderBase({ currentAgent, children }) {
  const value = useMemo(() => currentAgent, [currentAgent]);

  return <CurrentAgentContext.Provider value={value}>{children}</CurrentAgentContext.Provider>;
}

export const CurrentAgentProvider = connect(mapStateToProps)(CurrentAgentProviderBase);

function mapStateToProps({ getProvider }) {
  return {
    currentAgent: getProvider('currentAgent').get(),
  };
}

export function useCurrentAgent() {
  return useContext(CurrentAgentContext);
}
